<template>
  <div class="container-xxl" v-if="!loading">
    <div class="row m-1 justify-content-center favourite-ride">
      <div class="text-end pe-2 pt-3 d-flex justify-content-end">
<!--        <p class="fw-bold pt-4 pe-1">Park map:</p>-->
<!--        <div v-if="this.park.name = this.$route.params.parkSlug">-->
<!--          &lt;!&ndash; Button trigger modal &ndash;&gt;-->
<!--          <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#exampleModal">-->
<!--            <font-awesome-icon icon="fa-solid fa-map-location-dot" size="3x" color="#323054"/>-->
<!--          </button>-->
<!--          &lt;!&ndash; Modal &ndash;&gt;-->
<!--          <div class="modal modal-xl fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">-->
<!--            <div class="modal-dialog">-->
<!--              <div class="modal-content">-->
<!--                <div class="modal-header">-->
<!--                  <h1 class="modal-title fs-5" id="exampleModalLabel">{{ park.name.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) }}</h1>-->
<!--                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
<!--                </div>-->
<!--                <div class="modal-body text-center">-->
<!--                  <div>-->
<!--                  <img class="img-thumbnail" :src="'/img/maps/' + park.name.replace(/ /g, '-').replace(/'/g, '').replace(/,/g, '').replace('.', '').toLowerCase() + '.png'"  :alt="`${park.name.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()) } park map thumbnail image`">-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="modal-footer">-->
<!--                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal">-->
<!--                    <a :href="'/downloads/' + park.name.replace(/ /g, '-').replace(/'/g, '').replace(/,/g, '').replace('.', '').toLowerCase() + '.pdf'" target="_blank" class="text-light">Download Map</a>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div v-for="landName in park.lands" :key="landName">
        <h1 class="p-3">{{ landName.name }}</h1>
        <div v-for="rides in landName.rides" :key="rides" class="row-cols-12 text-center text-sm-start mt-4 mb-4">
          <div v-if="rides.is_open === true" class="card ride-card p-3">
            <div class="d-sm-flex justify-content-between">
              <h2>{{ rides.name }}</h2>
              <h4>Ride status: <span class="is-open">OPEN</span></h4>
            </div>
            <div v-if="rides.wait_time >= 60" :class="'long-wait'">
              <p>Current wait time: <strong>{{ rides.wait_time }} mins</strong></p>
            </div>
            <div v-else-if="rides.wait_time >= 30 && rides.wait_time <= 59" :class="'med-wait'">
              <p>Current wait time: <strong>{{ rides.wait_time }} mins</strong></p>
            </div>
            <div v-else class="good-wait">
              <p>Current wait time: <strong>{{ rides.wait_time }} mins</strong></p>
            </div>
            <div class="text-end d-flex justify-content-between">
              <p class="small text-start my-auto"><i>Wait time updated: {{ formatUpdatedDate(rides.last_updated) }}</i></p>
              <font-awesome-icon icon="fa-star" class="favourite-icon" :class="{ selected : isFavourited(rides.id) }" @click="toggleFavouriteFor(rides)" />
            </div>
          </div>
          <div v-else class="is-closed card ride-card p-3">
            <div class="d-sm-flex justify-content-between">
              <h2>{{ rides.name }}</h2>
              <h4 class="pt-3 pt-sm-0">Ride status: <span class="ride-closed">CLOSED</span></h4>
            </div>
            <div class="text-end d-flex justify-content-between">
              <p class="small text-start my-auto"><i>Wait time updated: {{ formatUpdatedDate(rides.last_updated) }}</i></p>
              <font-awesome-icon icon="fa-star" class="favourite-icon" :class="{ selected : isFavourited(rides.id) }" @click="toggleFavouriteFor(rides)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-center">
    <div role="status" class="spinner-border text-center mt-4"></div>
  </div>
</template>

<script>
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'park',
  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      land: {},
      park: {},
      isActive: false,
      loading: true,
      favourite: false,
      selectedRides: [],
      dateFormat: ''
    }
  },

  created() {
    const favourites = JSON.parse(localStorage.getItem('favourites')) || [];
    this.selectedRides = favourites;
  },

  mounted() {
    this.load();
  },
  methods: {

    formatUpdatedDate(dateStr) {
      // Variable created to get a new date, taking in a string
      const date = new Date(dateStr);
      // returning the date in localestring format - then you can use formatUpdatedDate in the vue component
      // like this {{ formatUpdatedDate(rides.last_updated) }} to change the format of the last_updated data being pulled through
      return date.toLocaleString();
    },

    load() {
      let parkId = false;
      this.dateFormat = new Date();
      // console.log(this.dateFormat);

      axios.get('/api/parks.json').then(response => {
        this.loading = false;

        for (let i = 0; i < response.data.length; i++) {
          for (let j = 0; j < response.data[i].parks.length; j++) {
            if (this.$route.params.parkSlug === response.data[i].parks[j].name.replace(/ /g, '-').replace(/'/g, '').replace(/,/g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/&/g, 'and').toLowerCase()) {
              parkId = response.data[i].parks[j].id;
                break;
              }
            }
          }

        if (parkId) {
          axios.get('/api/parks' + '/' + parkId + '/' + 'queue_times.json').then(response => {
            // The way the data is structured in the API, some parks have no lands and just rides,
            // so dummy land created below in order for rides to show on all parks with no real lands
            if (!response.data.lands.length && response.data.rides.length) {
              this.park = {
                'lands': [
                  {
                    name: 'Rides',
                    rides: response.data.rides
                  }
                ]
              };
            } else {
              this.park = response.data;
            }
          }).catch(error => {
            console.error('unable to retrieve the list of lands');
          });
        }
      }).catch(error => {
        console.error('unable to retrieve the list of lands');
      });
    },

    // getFavourites() {
    //   // Get existing favourites from localStorage
    //   const favourites = JSON.parse(localStorage.getItem('favourites')) || [];
    //
    // },

    toggleFavouriteFor(ride) {
      // Get existing favourites from localStorage
      // let favourites = JSON.parse(localStorage.getItem('favourites')) || [];

        let favourites = JSON.parse(localStorage.getItem('favourites')) || [];
        if (favourites.includes(ride.id)) {
          favourites = favourites.filter(id => id !== ride.id);
        } else {
          favourites.push(ride.id);
        }
        localStorage.setItem('favourites', JSON.stringify(favourites));
        this.selectedRides = favourites;
      },

    isFavourited(id) {
      return this.selectedRides.includes(id);
    },
  },
}
</script>